import gql from 'graphql-tag';

export const ModifyStayBooking = gql`
    mutation modifyStayBooking(
        $conversationId: String!
        $updateBookingRequest: UpdateBookingRequest!
    ) {
        modifyStayBooking(
            conversationId: $conversationId
            updateBookingRequest: $updateBookingRequest
        ) {
            conversationId
        }
    }
`;
